import { PayrollWindow } from 'app/store/usePayrollWindow'
import { useDatabase } from '../composables/database'

type PayrollModelReturn = {
  write: (data: PayrollWindow) => Promise<void>
  load: () => Promise<PayrollWindow>
  clear: () => Promise<void>
}
export const PayrollModel = (): PayrollModelReturn => {
  const { run, query } = useDatabase()

  const write = async (data: PayrollWindow) => {
    const sql = `
        INSERT OR REPLACE INTO payroll_window ('id', 'current_payroll_data')
        VALUES (0, ?);
    `
    await run(sql, [JSON.stringify(data)]).catch((error) => {
      console.log(error)
    })
  }
  const load = async () => {
    const sql = `
        SELECT * FROM payroll_window;
    `
    return await query(sql)
      .catch((error) => console.log(`Error loading payroll window: ${error}`))
      .then((payroll_window) => {
        if (payroll_window && typeof payroll_window !== 'undefined' && payroll_window.length > 0) {
          const data = JSON.parse(payroll_window[0]['current_payroll_data'])
          return data
        }
      })
  }
  const clear = async () => {
    const sql = `
        DELETE FROM payroll_window;
    `
    await run(sql, []).catch((error) => console.log(`Error deleting payroll windows: ${error}`))
  }
  return {
    write,
    load,
    clear,
  }
}
